import { CSSProperties } from 'react';
import { Text } from '~/commonComponents';
import { ReceiptV2Status } from '~/models';
import { Colors } from '~/themes/colors';

interface IProps {
  status: ReceiptV2Status;
}

export const ReceiptStatus = ({ status }: IProps) => {
  const getStyles = (): CSSProperties => {
    switch (status) {
      case ReceiptV2Status.Pending:
        return {
          color: Colors.secondary_500,
        };
      case ReceiptV2Status.Refunded:
        return {
          color: Colors.success_600,
        };
      case ReceiptV2Status.Succeeded:
        return {
          color: Colors.primary_500,
        };
      default:
        return {
          color: Colors.neutral_600,
        };
    }
  };

  return (
    <Text bold fontSize={13} style={{ ...getStyles() }} textTransform="uppercase">
      {status}
    </Text>
  );
};
